export const convertNumberToKbyte = (number) => number*1024;
export const convertKbyteToNumber = (bytes) => (bytes/1024).toFixed(1);
export const convertByteToSizeByte = (bytes) => {
    const unit = ['B', 'KB', 'MB', 'GB', 'TB'];
    const integer = parseInt(bytes);
    const pow = parseInt(Math.floor((integer ? Math.log(integer) : 0)/Math.log(1024)));
    return pow > 0 ? `${(integer/Math.pow(1024, pow)).toFixed(1)} ${unit[pow]}` : 0;
}